import {Component, ElementRef, HostListener, ViewChild} from "@angular/core";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {interval, Observable, Subscription} from "rxjs";
import {CodeInputComponent} from 'angular-code-input';
import {take} from "rxjs/operators";
import {LoginHub} from "src/app/services/Hub/hub.login.service";
import {LocalStorage} from "src/app/services/local-storage";
import {SessionService} from "src/app/services/session.service";
import {environment} from "src/environments/environment";
import {Client} from "../../../../services/API/client";
import {ModalAuthService} from "../../../../services/ux/modal-auth.service";
import {toastrService} from "../../../../services/ux/toastr.service";
import {PasswordValidator} from "../../../validators/match.component";
import { TranslateService } from "@ngx-translate/core";
import { UserHttpClientService } from "src/app/data/user-http-client.service";
import { Router } from "@angular/router";

@Component({
    selector: "app-helius-auth-modal",
    templateUrl: "modal-auth.component.html",
    styleUrls: ["modal-auth.component.css"]
})

export class ModalAuthComponent {
    newLogin = environment.newLogin;
    open = false;
    loginModal = true; // used to switch login/register modal
    regModal = false; // shfaq pjesen e pare te rregjistrimit
    reg2Modal = false; // shfaq pjesen e dyte te regjistrimit
    forgotPassModal = false;
    forgotPass2Modal = false;
    chooseOtpModal = false;
    confirmOtpModal = false;
    operationId = "";

    isLoading = false;

    //#region * Login

    // * Get value from login req
    isLoginRequestSent = false;
    wentOkay: boolean = null;
    //#endregion

    // * Get value from timer finishing or when server error
    shouldRetryLoginOption = false;

    // * Get value when user rejects the login request
    isRejected: boolean = null;

    // * Style object for no client
    readonly modalOnErrorStyleObj = {
        height: "90vh",
        overflow: "auto",
        transform: "translate3d(-50%, -5vh, 0)"
    };

    // * Use element to scroll on bottom
    @ViewChild("modalContent") divToScroll: ElementRef;

    @ViewChild('codeInput') codeInput !: CodeInputComponent;

    lform: FormGroup; // * Login Form Group

    //#region * Timer Manager
    timerSubs: Subscription = new Subscription();
    loginTimer: Observable<number>;
    seconds = 45;
    //#endregion

    //#endregion

    //#region Register Forms
    rform: FormGroup; // * Register Form Group
    r2form: FormGroup; // * Register2 form group
    //#endregion

    //#region Forgot Password Forms
    forgotPassForm: FormGroup; // * Forgot Password Form
    forgotPass2Form: FormGroup; // * Forgot Password Second Form
    //#endregion

    private readonly clientId: string = "EternaWebPosta";

    constructor(
        private modalService: ModalAuthService,
        private toastr: toastrService,
        public client: Client,
        private session: SessionService,
        public localStorage: LocalStorage,
        private fb: FormBuilder,
        private _hub: LoginHub,
        private http: HttpClient,
        private translateService: TranslateService,
        private userService: UserHttpClientService,
        private router: Router,
    ) {
        modalService.modalState$.subscribe((value) => {
            if (value && !this.session.isLoggedIn()) {
                this.prepareHub();
            } else if (!value) {
                this.lform.reset();
                this.rform.reset();
                this.r2form.reset();
                this._hub.hubConnection.stop();
                this.resetCountDownAndLoginUI();
                this.timerSubs.unsubscribe();
                this.isLoading = false;
                this.operationId = "";
            }
            this.open = value;
        });

        // * Will allways emit true values
        this._hub.retryLoginEventEmitter.subscribe((shouldRetry: boolean) => {
            this.timerSubs.unsubscribe();
            this.loginTimer.pipe(take(0));
            this.isLoading = false;
            this.shouldRetryLoginOption = shouldRetry;
        });

        // * Will allways emit true values
        this._hub.loginRejectEventEmitter.subscribe((event: boolean) => {
            this.isRejected = event;
            this.shouldRetryLoginOption = false;
            this.isLoading = false;
            this.lform.reset();
            this.timerSubs.unsubscribe();
            this.operationId = "";
        });

        // * Build login form
        this.lform = this.fb.group({
            email: ["", [Validators.required, Validators.email]],
            password: ["", Validators.required]
        });

        // * Build register form
        this.rform = this.fb.group({
            email: ["", [Validators.required, Validators.email]],
            emri: ["", Validators.required],
            mbiemri: ["", Validators.required],
            nrcel: ["", Validators.required]
        });

        // * Build register second form
        this.r2form = this.fb.group(
            {
                kodi: ["", Validators.required],
                password: ["", Validators.required],
                passwordConf: ["", Validators.required]
            },
            {
                validator: PasswordValidator.Match("password", "passwordConf")
            }
        );

        // * Build forgot password form
        this.forgotPassForm = this.fb.group({
            email: ["", [Validators.required, Validators.email]]
        });

        // * Build forgot password second form
        this.forgotPass2Form = fb.group(
            {
                kodi: ["", Validators.required],
                fpassword: ["", [Validators.required]],
                fpasswordConf: ["", Validators.required]
            },
            {
                validator: PasswordValidator.Match("fpassword", "fpasswordConf")
            }
        );
    }

    private prepareHub() {
        this._hub.buildConnection();
        this._hub.startConnection();
    }

    renderModalHeader() {
      let key: string = "ModalComponent.Auth.Registration"
      if (this.loginModal) key = "ModalComponent.Auth.Entry"
      if (this.forgotPassModal) key = "ModalComponent.Auth.ChangeThePassword"
      if (this.chooseOtpModal) key = "ModalComponent.Auth.ChooseYourWayToReceiveSecurityCode"
      if (this.confirmOtpModal) key = "ModalComponent.Auth.EnterYourSecurityCodeToContinue"
      return this.translateService.instant(key)
    }

    close() {
        this.modalService.close();
        this.codeInput.reset()
        this.openLogin();
    }

    backToLogin() {
      this.chooseOtpModal = false
      this.loginModal = true
    }

    openLogin() {
        this.loginModal = true;
        this.regModal = false;
        this.reg2Modal = false;
        this.forgotPassModal = false;
        this.forgotPass2Modal = false;
        this.chooseOtpModal = false;
        this.confirmOtpModal = false;
        this.operationId = "";
        this.lform.reset();
        this.rform.reset();
        this.forgotPassForm.reset();
        this.forgotPass2Form.reset();
    }

    openForgotPass() {
        this.forgotPassModal = true;
        this.regModal = false;
        this.reg2Modal = false;
        this.loginModal = false;
        this.forgotPass2Modal = false;
        this.chooseOtpModal = false;
        this.confirmOtpModal = false;
    }

    openChooseOtpModal() {
      this.forgotPassModal = false;
      this.regModal = false;
      this.reg2Modal = false;
      this.loginModal = false;
      this.forgotPass2Modal = false;
      this.chooseOtpModal = true;
      this.confirmOtpModal = false;
    }

    openConfirmOtpModal() {
      this.forgotPassModal = false;
      this.regModal = false;
      this.reg2Modal = false;
      this.loginModal = false;
      this.forgotPass2Modal = false;
      this.chooseOtpModal = false;
      this.confirmOtpModal = true;
    }

    onCodeChanged(event: any) {
      
    }

    onLogin() {
        if (this.isLoading || !this.lform.valid) {
            this.toastr.warning(this.translateService.instant("ModalComponent.Auth.PleaseFillInTheFields"))
            // this.toastr.warning("Ju lutem plotesoni fushat.");
            return;
        }

        this.resetCountDownAndLoginUI();

        // this.loginReq();
        this.newLogin 
          ? this.openChooseOtpModal()
          : this.loginMobile()
    }

    onLoginRetry() {
        if (!this.lform.valid) {
            this.toastr.warning(this.translateService.instant("ModalComponent.Auth.PleaseFillInEmailAndPassword"));
            return;
        }

        this.newLogin 
          ? this.openChooseOtpModal()
          : this.loginMobile()
    }

    private getSuccessOTPMessage(type: number) {
      let typeString = ""
      if (type === 1) typeString = this.translateService.instant("Email");
      if (type === 2) typeString = "SMS"

      return this.translateService.instant("ModalComponent.Auth.PleaseCheckToGetSecurityCode", { method: typeString })
    }

    loginMobile() {
      this.isLoading = true
      this.http
        .post(`${environment.backendBaseUrl}/api/auth/web-login-start`, {
            Email: this.lform.value.email,
            Password: this.lform.value.password,
            ConnectionId: this._hub.hubConnection.connectionId
        })
        .subscribe({
            next: () => {
                this.isLoginRequestSent = true;
                this.wentOkay = true;
                this.chooseOtpModal = false;
                this.loginModal = true;
                this.countDown(45);
            },
            error: (error: HttpErrorResponse) => {
                this.isLoginRequestSent = true;

                switch (error.error) {
                    case "user_not_found":
                        this.toastr.warning(this.translateService.instant("ModalComponent.Auth.UserNotExist"));
                        break;
                    case "invalid_credentials":
                        this.toastr.warning(this.translateService.instant("ModalComponent.Auth.DataNotAccurate"));
                        break;
                    case "username_password_required":
                        this.toastr.warning(this.translateService.instant("ModalComponent.Auth.FillInFieldsBelow"));
                        break;
                    case "no_client_associated":
                        this.wentOkay = false;
                        this.isLoading = false;
                        this.scrollToQrCode();
                        break;
                    default:
                        this.toastr.warning(
                          this.translateService.instant("ModalComponent.Auth.ServerProblem")
                        );
                        break;
                }
                this.isLoading = false;
            }
        });
    }

    loginReq(sendType?: number) {
      if (this.isLoading) return
        this.isLoading = true;
        this.client
          .postLogin("login", {
            grant_type: "password",
            client_id: "EternaWebPosta",
            Username: this.lform.value.email,
            Password: this.lform.value.password,
            ConnectionId: this._hub.hubConnection.connectionId,
            sendType
          })
          .then((data: { id: string, sent: boolean, type: number }) => {
            const { id, sent, type } = data
            if (!sent) {
              this.toastr.error(this.translateService.instant("ModalComponent.Auth.SomethingWrong"))
              return
            }

            this.toastr.success(this.getSuccessOTPMessage(type))
            this.operationId = id
            this.openConfirmOtpModal()
            this.isLoading = false
          })
          .catch(err => {
            this.toastr.error(this.translateService.instant("ModalComponent.Auth.WrongCredentials"));
            this.isLoading = false
          })
    }

    async verifyOTP(otp: string) {
      if (this.isLoading) return

      this.isLoading = true
      try {
        const data: any = await this.client
          .post("api/otp/verifyCode", {
            operationId: this.operationId,
            otp
          })
        this.localStorage.set(
          "auth",
          JSON.stringify({
            access_token: data.mobileToken.token,
            expires_in: data.mobileToken.expiresIn
          })
          );
        this.isLoading = false
        this.confirmOtpModal = false
        this.operationId = ""
        this.modalService.close();
        this.loginModal = true
        this.userService.getUserDetails().subscribe(data => {})
        this.router.navigateByUrl("/")
      } catch(err) {
        this.toastr.error(this.translateService.instant("ModalComponent.Auth.WrongSecurityCode"));
      }
      this.codeInput.reset()
      this.isLoading = false
    }

    private scrollToQrCode() {
        const el = this.divToScroll.nativeElement as HTMLDivElement;

        window.setTimeout(() => {
            el.scroll({
                top: 300,
                behavior: "smooth"
            });
        }, 100);
    }

    // * startPoint => Value of timer continuing to go down
    private countDown(startPoint: number) {
        // * Fire Every Second for x times (startPoint)
        this.loginTimer = interval(1000).pipe(take(startPoint));

        // * Fire incremental number on every second
        this.timerSubs = this.loginTimer.subscribe({
            next: (second: number) => {
                // * Add second +1 because it start at 0
                ++second;
                this.seconds = startPoint - second;
            },
            complete: () => {
                this.shouldRetryLoginOption = true;
                this.isLoading = false;
            }
        });
    }

    private resetCountDownAndLoginUI() {
        this.shouldRetryLoginOption = false;
        this.isLoginRequestSent = false;
        this.wentOkay = null;
        this.isRejected = null;
        this.seconds = 45;
    }

    finishLogin() {
        if (this.isLoading) {
            return;
        }

        this.isLoading = true;
        this.client
            .postLogin("login", {
                grant_type: "password",
                username: this.rform.value.email,
                password: this.r2form.value.password,
                client_id: this.clientId
            })
            .then((response: any) => {
                this.localStorage.set(
                    "auth",
                    JSON.stringify({
                        access_token: response.token,
                        expires_in: response.expires_in
                    })
                );

                // kthe login modal ne login page
                this.loginModal = true;
                this.reg2Modal = false;
                this.regModal = false;
                this.forgotPassModal = false;
                this.forgotPass2Modal = false;
                this.chooseOtpModal = false;
                this.confirmOtpModal = false;
                this.modalService.close();

                this.isLoading = false;
            })
            .catch((err) => {
                this.toastr.error(err.error_description);
                this.isLoading = false;
                return err;
            });
    }

    changePass() {
        if (this.isLoading || this.forgotPassForm.invalid) {
            return this.toastr.warning(this.translateService.instant("ModalComponent.Auth.EmailIncorrect"));
        }

        this.isLoading = true;
        return this.client
            .post("api/user/forgotPassword", {
                username: this.forgotPassForm.value.email
            })
            .then((res: any) => {
                this.forgotPass2Modal = true;
                this.isLoading = false;
            })
            .catch((error: any) => {
                if (error.error === "user_not_exist") {
                    this.toastr.error(this.translateService.instant("ModalComponent.Auth.UserNotExist"));
                    this.isLoading = false;
                }
            });
    }

    finishChangePass() {
        if (this.forgotPass2Form.invalid) {
            return this.toastr.error(this.translateService.instant("ModalComponent.Auth.DataNotAccurate"));
        }

        return this.client
            .post("api/user/resetPassword", {
                username: this.forgotPassForm.value.email,
                resetCode: this.forgotPass2Form.value.kodi,
                password: this.forgotPass2Form.value.fpassword
            })
            .then((res: any) => {
                this.forgotPassModal = false;
                this.forgotPass2Modal = false;
                this.isLoading = false;
                this.chooseOtpModal = false;
                this.confirmOtpModal = false;
                this.loginModal = true;
                return this.toastr.success(this.translateService.instant("ModalComponent.Auth.PasswordChangedSuccessfully"));
            })
            .catch((error: any) => {
                if (error.error == "old_password_is_same_as_new_password") {
                    return this.toastr.error(this.translateService.instant("ModalComponent.Auth.PleaseEnterNewPassword"));
                }
                if (error.error == "wrong_code") {
                    return this.toastr.warning(this.translateService.instant("ModalComponent.Auth.SecurityCodeIncorrect"));
                }
                this.isLoading = false;
            });
    }

    register() {
        if (this.isLoading) {
            return;
        }

        this.isLoading = true;
        this.client
            .post("api/auth/register", {
                email: this.rform.value.email,
                firstName: this.rform.value.emri,
                lastName: this.rform.value.mbiemri,
                celNr: this.rform.value.nrcel
            })
            .then((res: any) => {
                let infoMessage: string;
                // shfaqja e tabeles per konfirmimin te adreses

                if (res == "success") {
                    // shfaqja e tabeles per konfirmimin te adreses
                    this.reg2Modal = true;
                    // ruaj emailin per ti dhene konfirmimin
                    infoMessage = this.translateService.instant("ModalComponent.Auth.RegisterSuccessfully")
                } else if (res == "email_resent") {
                    infoMessage = this.translateService.instant("ModalComponent.Auth.UserRegestedOnce");
                } 
                this.toastr.info(infoMessage);
                this.isLoading = false;
                this.reg2Modal = true;
            })
            .catch((error: any) => {
                let message: string;
                if (error.error == "user_already_registered") {
                    message = this.translateService.instant("ModalComponent.Auth.UserAlreadyRegistered")
                    this.toastr.warning(message);
                }
                if (error.error == "internal_error") {
                    message = this.translateService.instant("ModalComponent.Auth.EmailFormatIsIncorrect")
                    this.toastr.warning(message);
                }
                this.isLoading = false;
                return error;
            });
    }

    // konfirmimi i rregjistrimit
    finishRegister() {
        if (this.isLoading) {
            return;
        }

        if (this.r2form.value.password !== this.r2form.value.passwordConf) {
            return this.toastr.error(
              this.translateService.instant("ModalComponent.Auth.ConflictPassword")
            );
        }
        this.isLoading = true;
        const userObj = {
            email: this.rform.value.email,
            password: this.r2form.value.passwordConf,
            confirmationCode: this.r2form.value.kodi
        };
        this.client
            .post("api/auth/finishRegister", userObj)
            .then((res: any) => {
                // kontrolli i responsit
                if (res == "success") {
                    this.isLoading = false;
                    this.finishLogin();
                }
            })
            .catch((err: any) => {
                let errorMessage: string;
                const error = err;

                if (err.error == "user_not_exist") {
                    errorMessage = this.translateService.instant("ModalComponent.Auth.UserNotExist");
                } else if (err.error == "wrong_confirmation_code") {
                    errorMessage = this.translateService.instant("ModalComponent.Auth.ConfirmationCodeIncorrect");
                } else if (err.error == "weak_password") {
                    errorMessage = this.translateService.instant("ModalComponent.Auth.WeakPassword");
                }

                this.toastr.error(errorMessage);
                this.isLoading = false;
            });
    }

    @HostListener("document:keyup", ["$event"])
    handleKeyUp(event: KeyboardEvent) {
        if (event.keyCode === 27 && this.open) {
            this.close();
        }
    }
}
